import {Component, Input, OnInit} from '@angular/core';
import {DeviceParamLirisV3} from "../../../../../../shared/classes/device/type-v3/device-param-liris-v3";

@Component({
    selector: 'app-param-calibration',
    templateUrl: './param-calibration.component.html',
    styleUrls: ['./param-calibration.component.css']
})
export class ParamCalibrationComponent implements OnInit {

    @Input('deviceParamLirisV3') deviceParamLirisV3: DeviceParamLirisV3 = new DeviceParamLirisV3();
    @Input('sensorType') sensorType: number = 6;

    constructor() {
    }

    ngOnInit() {
    }

}
